import { fetchWrapper } from '../Helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}/messages`;

export const chatService = {
    reportspam,
    reportMessage,
    getAllUsers,
    getMessages,
    saveMessage
};

function reportspam(id, param) {
    return fetchWrapper.post(`${baseUrl}/${id}/flag`, param);
}
function reportMessage(id, param) {
    return fetchWrapper.post(`${baseUrl}/${id}/flag`, param);
}
function getAllUsers() {
    return fetchWrapper.get(`${baseUrl}/users`);
}
function getMessages(id,types) {
    return fetchWrapper.get(`${baseUrl}/chatwith/${id}?receiver_type_id=${types}`);
}
function saveMessage(id, param) {
    return fetchWrapper.post(`${baseUrl}/chatwith/${id}`, param);
}